import { render, staticRenderFns } from "./PropostaAssinanteEdit.vue?vue&type=template&id=e5febf8a"
import script from "./PropostaAssinanteEdit.vue?vue&type=script&lang=js"
export * from "./PropostaAssinanteEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports